import styled from 'styled-components'

export const Heading1 = styled.h1`
  font-size: 3rem;
  font-weight: 400;
  line-height: 1.1;
  color: #333d48;
  margin: 0;
`

export const Heading2 = styled.h2`
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 1.3;
  color: #333d48;
  margin: 0;
`

export const Heading3 = styled.h3`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.5;
  color: #333d48;
  margin: 0;
`
